import "./App.css";
import RoutesApp from "../src/routes";
import ScrollToTop from "./components/scrollToTop/index";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <>
    <ScrollToTop />
      <RoutesApp />
      <ToastContainer position="bottom-right" autoClose={3000} />
    </>
  );
}

export default App;
